import Api from './Api'

class StationMessageService {
    createStationMessage = async newMessage => {
        return await Api().post('station-message', { ...newMessage, probes: newMessage.probes.map(p => p.probeId) })
    }

    getStationMessageProbes = async () => {
        return await Api().get('station-message', { params: { type: 'probes' } })
    }

    getAllStationMessages = async params => {
        return await Api().get('station-message', { params })
    }

    updateStationMessage = async message => {
        return await Api().put('station-message', {
            probes: message.probes.map(p => p.probeId),
            etText: message.locale.et,
            enText: message.locale.en,
            fiText: message.locale.fi,
            ltText: message.locale.lt,
            station_message_id: message.station_message_id,
            active_error_messages: message.active_probes?.map(p => p.probeId),
            error_type: message.type,
        })
    }

    deleteStationMessage = async id => {
        return await Api().delete('station-message', { params: { station_message_id: id } })
    }

    getStationErrorMessages = async () => {
        return await Api().get('station-message', { params: { type: 'error_messages' } })
    }
    downloadStationMessagesCSV() {
        return Api().get(`/station-messages/download`)
    }
}

export default new StationMessageService()
